<template>
  <div>
    <!-- Top Buttons -->
    <div class="d-flex justify-content-end mb-1">
      <b-button
        variant="outline-secondary"
        class="mr-1 hide-on-mobile"
        :title="$t('RETURN')"
        :to="{ name: $route.meta.listEmployeesRoute }"
      >
        <feather-icon icon="ArrowLeftIcon" class="mr-50 fi" />
        <span> {{ $t("RETURN") }} </span>
      </b-button>
      <b-button
        variant="outline-danger"
        class="mr-1 hide-on-mobile"
        @click="deleteEmployee"
        :title="$t('DELETE')"
      >
        <feather-icon icon="Trash2Icon" class="mr-50 fi" />
        <span> {{ $t("DELETE") }} </span>
      </b-button>
      <b-button
        variant="outline-primary"
        :title="$t('GENERATE WORKSHEET')"
        class="mr-1 hide-on-mobile"
        @click="generateWorkSheetPdf"
      >
        <feather-icon icon="FileTextIcon" class="mr-50 fi" />
        <span> {{ $t("GENERATE WORKSHEET") }} </span>
      </b-button>
    </div>

    <b-card>
      <b-row>
        <b-col
          class="avatar-section"
          :key="keyPhoto"
          xl="2"
          lg="3"
          md="4"
          sm="12"
          xs="12"
        >
          <template v-if="form.file != ''">
            <b-avatar ref="previewEl" class="user-avatar" rounded>
              <template #default>
                <b-img
                  class="user-img"
                  :src="form.file"
                  :alt="userData.fullName"
                  fluid
                />
                <div class="avatar-buttons">
                  <b-button
                    variant="outline-danger"
                    size="sm"
                    @click="clearFileData"
                    style="margin-right: 10px"
                  >
                    <feather-icon icon="TrashIcon" size="15" />
                  </b-button>
                  <b-button
                    variant="outline-success"
                    size="sm"
                    @click="updatePhoto"
                    style="margin-left: 10px"
                  >
                    <feather-icon icon="SaveIcon" size="15" />
                  </b-button>
                </div>
              </template>
            </b-avatar>
          </template>

          <b-avatar v-else ref="previewEl" class="user-avatar" rounded>
            <template #default>
              <b-img
                v-if="userData.photo != null"
                class="user-img"
                :src="userData.photo"
                :alt="userData.fullName"
                fluid
              />
              <b-icon
                v-else
                font-scale="3"
                icon="person-fill"
                class="user-img d-flex justify-content-center align-items-center h-100 w-75"
              ></b-icon>

              <div class="avatar-buttons">
                <b-button
                  variant="outline-success"
                  size="sm"
                  :title="$t('Change photo')"
                  @click="addFile"
                  style="margin-left: 10px"
                >
                  <feather-icon icon="ImageIcon" size="15" />
                </b-button>
              </div>
            </template>
          </b-avatar>

          <b-form-file
            ref="refInputEl"
            class="d-none"
            @change="fillFileData"
            accept="image/*"
          />
        </b-col>

        <b-col xl="10" lg="9" md="8" sm="12" xs="12">
          <b-row>
            <b-col md="6">
              <b-form-group
                label-cols-lg="5"
                label-cols-md="5"
                label-cols-sm="4"
                label-cols="12"
                content-cols-lg="7"
                content-cols-md="7"
                content-cols-sm="8"
                content-cols="12"
                label-class="text-truncate"
              >
                <template #label>
                  <feather-icon icon="UserIcon" class="mr-75" />
                  {{ $t("EMPLOYEE") }}
                </template>
                <b-skeleton v-if="!finishedLoading" type="input" />
                <b-form-input
                  v-if="finishedLoading"
                  v-model="userData.empoye_name"
                  :disabled="true"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label-cols-lg="5"
                label-cols-md="5"
                label-cols-sm="4"
                label-cols="12"
                content-cols-lg="7"
                content-cols-md="7"
                content-cols-sm="8"
                content-cols="12"
                label-class="text-truncate"
              >
                <template #label>
                  <feather-icon icon="PhoneIcon" class="mr-75" />
                  {{ $t("PHONE NUMBER") }}
                </template>
                <b-skeleton v-if="!finishedLoading" type="input" />
                <b-form-input
                  v-if="finishedLoading"
                  v-model="userData.cell_phone"
                  :disabled="true"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label-cols-lg="5"
                label-cols-md="5"
                label-cols-sm="4"
                label-cols="12"
                content-cols-lg="7"
                content-cols-md="7"
                content-cols-sm="8"
                content-cols="12"
                label-class="text-truncate"
              >
                <template #label>
                  <feather-icon icon="HomeIcon" class="mr-75" />
                  {{ $t("DEPARTMENT") }}
                </template>
                <b-skeleton v-if="!finishedLoading" type="input" />
                <b-form-input
                  v-if="finishedLoading"
                  v-model="userData.area"
                  :disabled="true"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label-cols-lg="5"
                label-cols-md="5"
                label-cols-sm="4"
                label-cols="12"
                content-cols-lg="7"
                content-cols-md="7"
                content-cols-sm="8"
                content-cols="12"
                label-class="text-truncate"
              >
                <template #label>
                  <feather-icon icon="MailIcon" class="mr-75" />
                  {{ $t("EMAIL") }}
                </template>
                <b-skeleton v-if="!finishedLoading" type="input" />
                <b-form-input
                  v-if="finishedLoading"
                  v-model="userData.work_email"
                  :disabled="true"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label-cols-lg="5"
                label-cols-md="5"
                label-cols-sm="4"
                label-cols="12"
                content-cols-lg="7"
                content-cols-md="7"
                content-cols-sm="8"
                content-cols="12"
                label-class="text-truncate"
              >
                <template #label>
                  <feather-icon icon="UserCheckIcon" class="mr-75" />
                  {{ $t("ROL") }}
                </template>
                <b-skeleton v-if="!finishedLoading" type="input" />
                <b-form-input
                  v-if="finishedLoading"
                  v-model="userData.rol"
                  :disabled="true"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label-cols-lg="5"
                label-cols-md="5"
                label-cols-sm="4"
                label-cols="12"
                content-cols-lg="7"
                content-cols-md="7"
                content-cols-sm="8"
                content-cols="12"
                label-class="text-truncate"
              >
                <template #label>
                  <feather-icon icon="CalendarIcon" class="mr-75" />
                  {{ $t("START DATE") }}
                </template>
                <b-skeleton v-if="!finishedLoading" type="input" />
                <!-- <b-form-input
                  v-if="finishedLoading"
                  v-model="userData.start_date"
                  :disabled="true"
                /> -->

                <kendo-datepicker
                  v-if="finishedLoading"
                  id="start_date"
                  v-model="userData.start_date"
                  v-mask="'##/##/####'"
                  class="form-control-kendo"
                  :class="[isDarkSkin ? ' bg-transparent' : '']"
                  :format="'MM/dd/yyyy'"
                  :disabled="true"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label-cols-lg="5"
                label-cols-md="5"
                label-cols-sm="4"
                label-cols="12"
                content-cols-lg="7"
                content-cols-md="7"
                content-cols-sm="8"
                content-cols="12"
                label-class="text-truncate"
              >
                <template #label>
                  <feather-icon icon="CircleIcon" class="mr-75" />
                  {{ $t("STATUS") }}
                </template>
                <b-skeleton v-if="!finishedLoading" type="input" />
                <b-form-input
                  v-if="finishedLoading"
                  :value="
                    userData.status === 'Active' ? $t('ACTIVE') : $t('INACTIVE')
                  "
                  :style="
                    userData.status === 'Active'
                      ? 'color:#00CC00;font-weight:bold'
                      : 'color:#FF0000;font-weight:bold'
                  "
                  :disabled="true"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <div>
      <b-nav card-header pills class="m-0">
        <b-nav-item
          :to="{ name: $route.meta.basicInformationRoute }"
          exact
          exact-active-class="sub-tab-nav"
          :link-classes="['sub-tab-nav', 'px-3', bgTabsNavs]"
        >
          {{ $t("BASIC INFORMATION") }}
        </b-nav-item>
        <b-nav-item
          :to="{ name: $route.meta.jobDetailsRoute }"
          exact
          exact-active-class="sub-tab-nav"
          :link-classes="['sub-tab-nav', 'px-3', bgTabsNavs]"
        >
          {{ $t("JOB DETAILS") }}
        </b-nav-item>

        <b-nav-item
          :to="{ name: $route.meta.scheduleRoute }"
          exact
          exact-active-class="sub-tab-nav"
          :link-classes="['sub-tab-nav', 'px-3', bgTabsNavs]"
        >
          {{ $t("SCHEDULE") }}
        </b-nav-item>
        <b-nav-item
          :to="{ name: $route.meta.filesRoute }"
          exact
          exact-active-class="sub-tab-nav"
          :link-classes="['sub-tab-nav', 'px-3', bgTabsNavs]"
        >
          {{ $t("FILES") }}
        </b-nav-item>
        <b-nav-item
          :to="{ name: $route.meta.vacacionesRoute }"
          exact
          exact-active-class="sub-tab-nav"
          :link-classes="['sub-tab-nav', 'px-3', bgTabsNavs]"
        >
          {{ $t("VACACIONES") }}
        </b-nav-item>
      </b-nav>
      <div class="border-top-info border-3 px-0">
        <router-view :key="$route.name" />
      </div>
    </div>
  </div>
</template>

<script>
import { avatarText } from "@core/utils/filter";
import { mapGetters, mapState } from "vuex";
import EmployeesService from "@/views/rrhh/views/employees/services/employee.service.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  data() {
    return {
      form: {
        file: "",
        image: "",
        remove: false,
        photo: "",
      },

      employee: null,
      keyPhoto: 1,
      finishedLoading: false,
    };
  },
  computed: {
    ...mapState({
      S_EMPLOYEE_ID: (state) => state.RRHHEmployeesStore.S_EMPLOYEE_ID,
      S_EMPLOYEE_INFO: (state) => state.RRHHEmployeesStore.S_EMPLOYEE_INFO,
    }),
    ...mapGetters({
      currentUser: "auth/currentUser",
      userData: "RRHHEmployeesStore/G_EMPLOYEE_INFO",
      S_EMPLOYEE_ID: "RRHHEmployeesStore/G_EMPLOYEE_ID",
    }),
  },

  async created() {
    try {
      this.addPreloader();
      await this.$store.dispatch(
        "RRHHEmployeesStore/A_EMPLOYEE_INFO",
        this.$route.params.id
      );
    } catch (error) {
      console.log(error);
    } finally {
      this.finishedLoading = true;
      this.removePreloader();
    }
  },

  methods: {
    async deleteEmployee() {
      const params = {
        id: this.$route.params.id,
      };
      try {
        const response = await this.showConfirmSwal();
        if (response.isConfirmed) {
          //   await EmployeesService.deleteEmployee(params);
          await this.$router.push({ name: "list-employees" });

          this.showSuccessSwal("Employee has been deleted successfully");
        }
      } catch (e) {
        this.showErrorSwal(e);
        return [];
      }
    },

    avatarText(fullName) {
      return avatarText(fullName);
    },
    addFile() {
      this.$refs.refInputEl.$el.childNodes[0].click();
    },
    async fillFileData(event) {
      await this.$refs.refInputEl.files;
      const image = this.$refs.refInputEl.files[0];
      this.form.image = image.name;

      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = () => (this.form.file = reader.result);
      this.form.size = image.size;
      this.form.type = image.type;
      this.form.remove = true;
      this.form.photo = image;
    },
    clearFileData() {
      this.form.file = "";
      this.form.image = "";
      this.form.remove = false;
      this.$refs.refInputEl.reset();
    },

    async updatePhoto() {
      try {
        this.addPreloader();
        const params = new FormData();
        params.append("photo", this.form.photo);
        params.append("namedoc", this.form.image);
        params.append("employee_id", this.$route.params.id);
        params.append("size", this.form.size);
        params.append("type", this.form.type);
        const response = await EmployeesService.updatePhoto(params);
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    async generateWorkSheetPdf() {
      try {
        this.addPreloader();
        const params = {
          id: this.$route.params.id,
        };
        const response = await EmployeesService.generateWorkSheetPdf(params);
        if (response.status == 200) {
          await this.forceFileDownloadPdf(response);
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: this.$t("WorkSheet generated sucessfully"),
              icon: "CoffeeIcon",
              variant: "success",
              text: this.$t("WorkSheet generated sucessfully"),
            },
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>

<style lang="scss">
@media screen and(max-width: 1200px) and (min-width: 968px) {
  .information-form {
    margin-top: 30px;
  }
}

.hide-on-mobile > span {
  @media screen and (max-width: 968px) {
    display: none;
  }
}

.hide-on-mobile > .fi {
  @media screen and (max-width: 968px) {
    text-align: center;
    margin: 0px !important;
    padding: 0px !important;
  }
}

.user-avatar {
  width: 100% !important;
  max-width: 100% !important;
  max-height: 100% !important;
  height: 100% !important;
  pointer-events: auto !important;
}

.user-img {
  border-radius: 5px !important;
  max-width: 100% !important;
  max-height: 230px !important;
  min-height: 230px !important;
}

.b-avatar-custom {
  align-items: unset !important;
}

.avatar-buttons {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  right: 0;
  bottom: 0;
  display: none;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.user-avatar:hover .avatar-buttons {
  display: flex !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
}
@media screen and (max-width: 770px) {
  .user-avatar {
    max-width: 250px !important;
    max-height: 250px !important;
    margin: auto !important;
    text-align: center !important;
    display: block !important;
  }
  .user-img {
    max-width: 250px !important;
    max-height: 250px !important;
    margin: auto !important;
    text-align: center !important;
    display: block !important;
  }
  .avatar-section {
    margin: 10px 10px 30px 10px !important;
  }
}
</style>
